import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { encryptEuroConfPayload } from "../mutations/euroConferenceMutations";
import sharedDatasInstance from "../sharedDatas";
import {useMutation} from "@1f/react-sdk";

export const EuroConferenceApi = () => {
    const userName = sharedDatasInstance.getPropertyByName("userModel")?.username ?? null;
    const tsId = sharedDatasInstance.getPropertyByName("userModel")?.emailTsId ?? null;
    const loggedUserId = sharedDatasInstance.getPropertyByName("userId");
    const tenantModel = sharedDatasInstance.getPropertyByName("tenantModel");
    let errorApiHelpers = apiErrorHelper()
    const apiGetEuroconferenceCryptedParams = useMutation(
        encryptEuroConfPayload,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )

    const GetEncryptedParams = async (itemId) => {
        try {            
            const jsonToEnc = {
                pIva: tenantModel.vatNumber,
                id: itemId.toString(),
                search: "",
                userfullname: userName,
                context: "TS420",
                from: "TS Antiriciclaggio",
                userid: loggedUserId,
                teamsystemid: tsId,
            };

            const encryptedResp = await apiGetEuroconferenceCryptedParams.fetch({
                payload: jsonToEnc
            })

            if(encryptedResp){                
                return encryptedResp.data.data.encryptEuroConfPayload
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error)
            throw new Error(errorMessage || "Impossibile generare i parametri per EuroConference: " + error.message);
        }
    }
    const BuildEuroConferenceUrl = async (itemId) => {        
        const cryptedContentResp = await GetEncryptedParams(itemId)
        let url = cryptedContentResp.url
        return url;
    }

    return {                
        BuildEuroConferenceUrl
    }
}